import type { FaireProductEntity } from "../../entity_types/product";

export const p_dhxhxst4nd: FaireProductEntity = {
  token: "p_dhxhxst4nd",
  type: "product",
  name: "Seaweed Coastal Ocean Botanical Beach Canvas Tote Bag",
  brandName: "ANNGOTI",
  imageUrl:
    "https://cdn.faire.com/fastly/1b2bab50c646608c53b1f568890852adb2afa2a5f4ff60bb8acaa4269396f0a1.jpeg",
  priceDollars: 19.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/1034726d3c361262089ff3c6ee9d3e924c0c9828eb62dd6c70fd16b7487c621f.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
